<phdsoft-window [options]="optionsWindow" >
  <div header>
    <strong>Full Ids Change</strong>
  </div>
  <div content>
    <div class="container">
      <div class="p-fluid" style="max-width: 500px;">
        <div class="row">
          <div class="col" style="margin:10px 0px;">
            <div class="input-container">
  
              <div class="dimension-container row">
                <label class="col-3">Select Full Ids Elements to change</label>
                <button (click)="onSelectElementFullId()" class="col-4"></button>
              </div>
  
              <div class="dimension-container row">
                <label class="col-3">Select Full Id Target element</label>
                <button (click)="onSelectFullIdTarget()" class="col-4"></button>
              </div>

              <div class="dimension-container row" style="margin-bottom: 0px;">
                <label class="col-3">Execute Change:</label>
                <button (click)="onExecuteChangeButtonClick()" class="col-4"></button>
              </div>

              <div class="dimension-container row" style="margin-bottom: 0px;">
                <label class="col-3">Clear Full Id:</label>
                <button (click)="clear()" class="col-4"></button>
              </div>

              <div class="dimension-container row" style="margin-bottom: 0px;">
                <label class="col-3">Save:</label>
                <button (click)="save()" class="col-4"></button>
              </div>

              <div class="dimension-container row" style="margin-bottom: 0px;">
                <label class="col-3">Cancel:</label>
                <button (click)="cancel()" class="col-4"></button>
              </div>
  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div content>
    <div class="container">
      <div class="p-fluid" style="max-width: 500px;">
        <div class="row">
          <div class="col" style="margin:10px 0px;">
            <div class="input-container">
  
              <div class="dimension-container row">
                <label class="col-3">Inspect Select:</label>
                <button (click)="onInspectSelectButtonClick()" class="col-4"></button>
              </div>
  
              <div class="dimension-container row">
                <label class="col-3">Target Select:</label>
                <button (click)="onTargetSelectButtonClick()" class="col-4"></button>
              </div>
  
              <div class="dimension-container row" style="margin-bottom: 0px;">
                <label class="col-3">Execute Change:</label>
                <button (click)="onExecuteChangeButtonClick()" class="col-4"></button>
              </div>

              <div class="dimension-container row" style="margin-bottom: 0px;">
                <label class="col-3">Stop Inspect Change:</label>
                <button (click)="onStopInspectionChangeButtonClick()" class="col-4"></button>
              </div>
  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  
</phdsoft-window>
